import Vue from 'vue'
import store from '../store'
import appRuntime from '@it-enterprise/web-app-runtime'
import auth from '@it-enterprise/jwtauthentication'
import router from '../router'
import { GraphqQlApi as api, getClient } from '@/api/api.js'
import InitPagePlayer from './pagePlayer'
let modelId = window.appConfig.ModelGuid
const registerAppRuntime = api.getModelFromGqlAsync(modelId).then(response => {
  let object = response.data.webAppModelerQuery.model
  let model = JSON.parse(object.model)
  model['$ID'] = object.id
  model['Name'] = object.name
  return Init(Vue, appRuntime, store, auth, router, model).then(() => {
    InitPagePlayer(Vue, store.getters.DataSources)
  })
})

function Init(Vue, appRuntime, store, auth, router, model) {
  return new Promise((resolve) => {
    Vue.use(appRuntime, {
      store,
      auth,
      router,
      model,
      gqTools: { getClient }, // GraphQL Tools
      installCallback() {
        authEventBus(Vue)
        return resolve()
      }
    })
  })
}

function authEventBus (Vue) {
  Vue.$authEventBus.onBeforeSignIn(() => {
    store.commit('CLEAR_ERROR')
  })
  Vue.$authEventBus.onAfterSignIn(() => {
    // выполняется только после логина
  })
  Vue.$authEventBus.onSignInError((message) => {
    store.commit('SET_ERROR', { text: message.errorMessage })
  })
  Vue.$authEventBus.onStartProcessing(() => {
    store.commit('SET_PROCESSING', true)
  })
  Vue.$authEventBus.onEndProcessing(() => {
    store.commit('SET_PROCESSING', false)
  })
  Vue.$authEventBus.onSignOut(() => {
    // apolloClientClearCache()
    Vue.$routerCore.GoToSignIn()
  })

  Vue.$authCore.SetAdditionalUserDataHandler(
    async () => {
      Vue.$authCore.SetUserRole('User')

      // выполняется после логина и при аутентификации по токену
      // await store.dispatch('SET_ADDITIONAL_DATA')

      // if (store.getters.userGroup == GROUPPM) {
      //   Vue.$authCore.SetUserRole('Admin')
      // } else if (store.getters.userGroup == GROUPUSER) {

      // } else {
      //   Vue.$authCore.SetUserRole('Guest')
      // }
    }
  )
}

export default registerAppRuntime